/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { htmlspecialchars } from './util.js';
import { mj } from './page-mj.js';
import { postToBackend } from './fetch-util.js';
import { mjt } from './i18ntexts.js';
import { MDLocale } from './locale-impl.js';


export let MDTrees = function(mj) {

	var m_rtd_callbacks = [];
	// var m_tree_data_refreshed_observers = [];

	function ensureTreeDataLoaded( ondone ) {
		if( !ondone ) ondone = function() {};
		if( mj.hasOwnProperty('trees') && mj.trees!=null ) ondone();
		else refreshTreeData(ondone);
	}

	function refreshTreeData( callback, skip_upload_and_edit, skip_mod_crd ) {
		m_rtd_callbacks.push(callback);
		if( m_rtd_callbacks.length>1 ) {
			// another query is already running..
			// callback will be called when that one finishes
			return;
		}
		var postdata = 'compact=1';
		if( skip_upload_and_edit ) postdata += '&skip_upload_and_edit=1';
		if( skip_mod_crd ) postdata += '&skip_mod_crd=1';
		postToBackend( 'json/widgets/trees-all_data', postdata, function refreshTreeData_success(j) {
			if( !j ) return;
			for( var tree_id in j.trees ) {
				if( !j.trees.hasOwnProperty(tree_id) ) continue;

				var tree = j.trees[tree_id],
					tn0 = tree.nodes,
					unlinked_nodes = {},
					last_node = { cat_id:0, parent:0, left:0, right:0 };

				tree.tree_id = tree_id;

				var tn1 = {};
				let tno1 = new Array(tn0.length);
				for( var i=0; i<tn0.length; ++i ) {
					var n0 = tn0[i],
						n0l = n0.length,
						cat_id = n0[0],
						parent = n0[1],
						left = n0[2],
						depth = 0;

					// parent=== 0  =>  last_node parent
					// parent===-1  =>  last_node cat_id
					if( parent===0 ) parent = last_node.parent;
					else if( parent===-1 ) parent = last_node.cat_id;

					// compute depth (with invisible nodes in mind... = means, nodes that user does not see, because of permission restrictions)
					if( parent!==0 ) {
						if( tn1.hasOwnProperty(parent) && !unlinked_nodes.hasOwnProperty(parent) ) {
							depth = 1 + tn1[parent].depth;
						} else {
							depth = -1;
							unlinked_nodes[cat_id] = cat_id;
						}
					}

					//   left=== 0  =>  last_node right + 1
					//   left===-1  =>  last_node left + 1
					if( left===0 ) left = last_node.right+1;
					else if( left===-1 ) left = last_node.left+1;

					if( n0l < 5 ) { //skip_mod_crd
						n0[5] = '';	// crd_dt
						n0[6] = ''; // crd_by
						n0l = 6;
					}

					// store node
					last_node = tn1[cat_id] = {
						cat_id: cat_id,
						parent: parent,
						depth:  depth,
						left:   left,
						right:  left+n0[3],
						name:   n0[4],
						crd_dt: n0[5],
						crd_by: n0[6],
						mod_dt: n0l<8||n0[7]===0 ? n0[5] : n0[7],
						mod_by: n0l<9||n0[8]===0 ? n0[6] : n0[8],
					};
					tno1[i] = cat_id;
				}
				tree.nodes = tn1;
				tree.nodes_order = tno1;
			}
			mj.trees = j.trees;
			mj.trees_order = j.trees_order;

			if( !skip_upload_and_edit ) {
				mj.upload_categories = j.upload_categories===0 ? mj.trees[1].nodes_order : j.upload_categories;
				mj.edit_categories = j.edit_categories===0 ? mj.trees[1].nodes_order : ( j.edit_categories===-1 ? mj.upload_categories : j.edit_categories );
				mj.edit_trees = j.edit_trees;
			}

			// mj.category_parents = _getCategoryParents(mj.trees);
			initCategoryParents();

			while( m_rtd_callbacks.length ) {
				var first_cb = m_rtd_callbacks.shift();
				if( first_cb ) first_cb();
			}

			// $.each( m_tree_data_refreshed_observers, function(idx,fn) {
			// 	fn(skip_upload_and_edit,skip_mod_crd);
			// } );

		}, true );
	}

	function _getCategoryParents( trees ) {
		var parents = { 0:0 };
		for( var tree_id in trees ) {
			if( !trees.hasOwnProperty(tree_id) ) continue;
			var tn = trees[tree_id].nodes;
			for( var cat_id in tn ) {
				if( !tn.hasOwnProperty(cat_id) ) continue;
				parents[cat_id] = tn[cat_id].parent;
			}
		}
		return parents;
	}

	function initCategoryParents() {
		mj.category_parents = _getCategoryParents(mj.trees);
	}


	function getDynatreeObjectFromTree( tree_id, with_other_node, with_unlinked_nodes, with_unknown_node ) {
		const tree = mj.trees[tree_id];
		const tree_nodes = tree.nodes;
		const tno = tree.nodes_order;
		const tnolen = tno.length;
		const root_id = tree.root_id;
		var i, cid, pid, cnode;

		//TODO: optimize tree building code ... START...

		var children_ordered = {};
		for( i=0; i<tnolen; ++i ) {
			cid = tno[i];
			pid = tree_nodes[cid].parent;
			if( children_ordered.hasOwnProperty(pid) ) {
				children_ordered[pid].push(cid);
			} else {
				children_ordered[pid] = [cid];
			}
		}

		function build_dt_obj_children( cat_id ) {
			//var data = { key:cat_id, title:htmlspecialchars(tree_nodes[cat_id].name) };
			if( children_ordered.hasOwnProperty(cat_id) ) {
				const co = children_ordered[cat_id];
				const colen = co.length;
				if( colen > 0 ) {
					var children = [];
					for( var i=0; i<colen; ++i ) {
						const child_cat_id = co[i];
						const childsChildren = build_dt_obj_children(child_cat_id);
						children.push( {
							key: child_cat_id,
							title: htmlspecialchars(tree_nodes[child_cat_id].name),
							children: childsChildren,
						} );
					}
					return children;
				}
			}
			return null;
		}

		// start with root category node
		const rootChildren = build_dt_obj_children(root_id);
		const root_nodes = [ {
			key: root_id,
			title: htmlspecialchars(tree_nodes[root_id].name),
			children: rootChildren,
		} ];

		//...END (TODO: optimize tree building code)


		if( with_other_node ) {
			// add the 'other' node
			root_nodes.push( { key:0, xtype:'other', title:mjt('category-other') } );
		}
		if( with_unlinked_nodes ) {
			// find unlinked nodes
			var unlinked_nodes_hash = {};
			var unlinked_nodes_array = [];
			for( i=0; i<tnolen; ++i ) {
				cid = tno[i];
				cnode = tree_nodes[cid];
				pid = cnode.parent;
				if( pid!=0 && ( !tree_nodes.hasOwnProperty(pid) || unlinked_nodes_hash.hasOwnProperty(pid) ) ) {
					// parent is unknown -> add to unlinked ...
					unlinked_nodes_hash[cid] = cnode;
					unlinked_nodes_array.push(cid);
				}
			}
			var unalen = unlinked_nodes_array.length;

			const build_unlinked_nodes_children = function( parent_id ) {
				var result_objs = [];
				for( var i=0; i<unalen; ++i ) {
					const cid = unlinked_nodes_array[i];
					const cnode = unlinked_nodes_hash[cid];
					if( cnode.parent == parent_id ) {
						var data = {
							key: cid,
							xtype: 'unlinked',
							title: htmlspecialchars(cnode.name),
						};
						const children = build_unlinked_nodes_children(cid);
						if( children.length ) data.children = children;
						result_objs.push(data);
					}
				}
				return result_objs;
			};

			// add unlinked root nodes to root
			for( i=0; i<unalen; ++i ) {
				cid = unlinked_nodes_array[i];
				cnode = unlinked_nodes_hash[cid];
				if( !unlinked_nodes_hash.hasOwnProperty(cnode.parent) ) {
					var data = {
						key: cid,
						xtype: 'unlinked',
						title: htmlspecialchars(cnode.name),
					};
					const children = build_unlinked_nodes_children(cid);
					if( children.length ) data.children = children;
					root_nodes.push(data);
				}
			}
		}
		if( with_unknown_node ) {
			// add the 'other' node
			root_nodes.push( { key:-1, xtype:'unknown', title:mjt('category-unknown') } );
		}
		return root_nodes;
	}

	function getTreeIdFromCategoryId( cat_id ) {
		for( var xt in mj.trees ) {
			if( mj.trees[xt].nodes.hasOwnProperty(cat_id) ) return xt;
		}
		return null;
	}

	function getParentIdFromCategoryId( cat_id ) {
		if( cat_id<=0 ) return null; // whatever
		return mj.category_parents.hasOwnProperty(cat_id) ? mj.category_parents[cat_id] : null;
	}

	function getCategoryNode( tree_id, cat_id ) {
		var tree = mj.trees[tree_id];
		return tree && tree.nodes.hasOwnProperty(cat_id) ? tree.nodes[cat_id] : null;
	}

	function isChildCategoryIdOf( cat_id, parent_candidate_id ) {
		if( cat_id<=0 ) return false; // whatever
		if( mj.category_parents.hasOwnProperty(cat_id) ) {
			var p = mj.category_parents[cat_id];
			return p==parent_candidate_id || isChildCategoryIdOf(p,parent_candidate_id);
		}
		return false;
	}

	function foreachCategoryNodeOrdered( tree_id, nodecb ) {
		var tree = mj.trees[tree_id],
			tree_nodes = tree.nodes,
			tno = tree.nodes_order,
			tnolen = tno.length;
		for( var i=0; i<tnolen; ++i ) {
			var cid=tno[i], cnode=tree_nodes[cid];
			if( nodecb.call(cnode,cid,cnode)===false ) break;
		}
	}

	function foreachChildCategoryNodeOrdered( tree_id, parent_id, nodecb ) {
		var tree = mj.trees[tree_id],
			tree_nodes = tree.nodes,
			tno = tree.nodes_order,
			tnolen = tno.length;
		for( var i=0; i<tnolen; ++i ) {
			var cid=tno[i], cnode=tree_nodes[cid];
			if( cnode.parent==parent_id ) {
				if( nodecb.call(cnode,cid,cnode)===false ) break;
			}
		}
	}

	function foreachDescendantCategoryNodeOrdered( tree_id, parent_id, nodecb ) {
		var tree = mj.trees[tree_id],
			tree_nodes = tree.nodes,
			tno = tree.nodes_order,
			tnolen = tno.length,
			parent_node = tree_nodes.hasOwnProperty(parent_id) ? tree_nodes[parent_id] : null;
		if( parent_node===null ) return false;
		for( var i=0; i<tnolen; ++i ) {
			var cid=tno[i], cnode=tree_nodes[cid];
			if( cnode.left > parent_node.left && cnode.right < parent_node.right ) {
				if( nodecb.call(cnode,cid,cnode)===false ) break;
			}
		}
	}

	function isAlphabeticallySorted( tree_id, parent_id ) {
		var prev_name = null,
			result = true;
		foreachChildCategoryNodeOrdered( tree_id, parent_id, function( cat_id, cnode ) {
			if( prev_name!==null ) {
				if( MDLocale.localized_string_compare(cnode.name,prev_name) < 0 ) {
					result = false;
					return false;
				}
			}
			prev_name = cnode.name;
		} );
		return result;
	}


	function hasChildren( tree_id, parent_id ) {
		var cnode = getCategoryNode(tree_id,parent_id);
		if( cnode===null ) return false;
		return cnode.right-cnode.left > 1;
	}

	function hasSiblings( tree_id, cat_id ) {
		var cnode = getCategoryNode(tree_id,cat_id);
		if( cnode===null ) return false;
		var pnode = getCategoryNode(tree_id,cnode.parent);
		if( pnode===null ) return false;
		return !( cnode.left==pnode.left+1 && cnode.right==pnode.right-1 );
	}

	function getFirstChildId( tree_id, parent_id ) {
		var result = null;
		foreachChildCategoryNodeOrdered(tree_id,parent_id,function(cid,cnode) {
			result = cid;
			return false;
		});
		return result;
	}

	return {
		// bindTreeDataRefresh: function( fn ) {
		// 	m_tree_data_refreshed_observers.push(fn);
		// },

		ensureTreeDataLoaded,
		refreshTreeData,

		getDynatreeObjectFromTree,

		initCategoryParents,

		getTreeIdFromCategoryId,
		getParentIdFromCategoryId,
		getCategoryNode,
		isChildCategoryIdOf,
		foreachCategoryNodeOrdered,
		foreachChildCategoryNodeOrdered,
		foreachDescendantCategoryNodeOrdered,
		isAlphabeticallySorted,
		hasChildren,
		hasSiblings,
		getFirstChildId,

	};
}(mj); // namespace MDTrees
